.rfi-card {
  cursor: pointer;
  margin: 0;
  background-color: #272727;
  margin-bottom: 8px;
}

.rfi-card-title{
  display: flex;
  justify-content: space-between;
}

.draft-rfi {
  background: repeating-linear-gradient(
    45deg,
    #222222,
    #222222 10px,
    #2a2a2a 10px,
    #2a2a2a 20px
  );
}